export const messages = {
  en: {
    information: {
      title: 'Information',
      helpCenter: 'Help Center',
      news: 'News',
      content: 'Content'
    }
  },
  zh: {
    information: {
      title: '资讯',
      helpCenter: '帮助中心',
      news: '新闻',
      content: '内容'
    }
  }
}